import { signIn } from "@/actions/_archive/auth/signIn"
import { SignInInput } from "@/actions/_archive/auth/signIn/signIn.interface"
import { useRequest } from "@/utils/request"

export function useSignIn() {
  const requestClient = useRequest()
  return async (input: SignInInput) => await signIn(requestClient, input)
}
